import React, { useEffect } from 'react'
import { faAdd, faCheck, faXmark } from '@fortawesome/free-solid-svg-icons'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  DcOverlaySlider,
  PixelIcon,
  PixelPageContainer,
  PixelTable,
  PixelText,
  Section,
  SectionActions,
  SectionContent,
} from 'pixel-base'

import { get } from 'utils/api-routes.util'

import WarehouseDetail from './components/WarehouseDetails'
import WarehouseForm from './components/WarehouseForm'

const breadcrumbs = [
  {
    name: 'Locations',
    active: false,
  },
  {
    name: 'Warehouses',
    active: true,
  },
]
const Warehouse = () => {
  const [warehouses, setWarehouses] = React.useState<any>([])
  const [tableLoading, setTableLoader] = React.useState(true)
  const [showModal, setShowModal] = React.useState(false)
  const [showDetailModal, setShowDetailModal] = React.useState(false)
  const [warehouseID, setWarehouseID] = React.useState(null)
  const [zonesList, setZonesList] = React.useState<any>([])
  const getAllSuppliers = () => {
    setTableLoader(true)
    get('/warehouses').subscribe((res: any) => {
      setWarehouses(res.response.data)
      setTableLoader(false)
    })
  }
  const getSources = () => {
    get('/location/zones').subscribe((res: any) => {
      setZonesList(res.response.data)
    })
  }
  useEffect(() => {
    getAllSuppliers()
    getSources()
  }, [])
  const columns = [
    {
      dataKey: 'name',
      name: <PixelText>Warehouse Name</PixelText>,
      sortable: true,
      width: '50%',
      selector: (row) => (
        <PixelText multiLine showToolTip tooltipPlacement="bottom">
          {row.name}
        </PixelText>
      ),
    },

    {
      dataKey: 'city',
      name: 'City',
      sortable: true,
      width: '20%',
      selector: (row) => row.city || '--',
    },
    {
      dataKey: 'phone',
      name: <PixelText>Contact Number</PixelText>,
      sortable: true,
      width: '20%',
      selector: (row) => row.phone || '--',
    },

    {
      dataKey: 'is_default',
      name: <PixelText>Is Default</PixelText>,
      sortable: true,
      width: '10%',
      selector: (row) => (
        <PixelIcon
          icon={row.is_default ? faCheck : faXmark}
          color={row.is_default ? 'green' : 'red'}
        />
      ),
    },
  ]
  const conditionalRowStyles = [
    {
      when: (row) => row.is_default,
      style: {
        backgroundColor: '#f5f5f5',
      },
    },
  ]
  const onRowClicked = (row) => {
    setWarehouseID(row.id)
    setShowDetailModal(true)
  }
  // navigate(`/locations/warehouses/detail/${row.id}`)

  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0px' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <SectionActions
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                padding: '5px 20px',
              }}
            >
              <DcButton
                size="sm"
                onClick={() => {
                  setShowModal(true)
                }}
              >
                <PixelIcon color="white" icon={faAdd} /> Add warehouse
              </DcButton>
            </SectionActions>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            <PixelTable
              columns={columns}
              data={warehouses}
              conditionalRowStyles={conditionalRowStyles}
              progressPending={tableLoading}
              onRowClicked={onRowClicked}
              highlightOnHover
              pointerOnHover
              fixedHeader
              fixedHeaderScrollHeight="calc(100vh - 210px)"
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      <DcOverlaySlider
        isOpen={showDetailModal}
        onClose={() => setShowDetailModal(false)}
        title={'Warehouse Details'}
        width="70%"
        padding="0px"
      >
        <WarehouseDetail
          warehouseID={warehouseID}
          setShowDetailModal={setShowDetailModal}
        />
      </DcOverlaySlider>

      {showModal && (
        <DcOverlaySlider
          width="40%"
          title={'Add Warehouse'}
          onClose={() => setShowModal(false)}
          isOpen={showModal}
        >
          <SectionContent>
            <WarehouseForm
              zonesList={zonesList}
              show={showModal}
              warehouse={null}
              warehouseId={null}
              handleClose={(data, action) => {
                if (action === 'add') {
                  setWarehouses([data, ...warehouses])
                }
                setShowModal(false)
              }}
            />
          </SectionContent>
        </DcOverlaySlider>
      )}
    </>
  )
}

export default Warehouse
